import apiClient from './api'

export default {
    async get () {
        return await apiClient.get('/profile')
    },
    async edit (params) {
        return await apiClient.post('/profile', params)
    },
}